export const getUrl = () => {
    const env = window.location.href.includes('dev')
        ? 'dev' : window.location.href.includes('staging')
            ? 'staging' : 'prod';
    switch (env) {
        case 'dev':
            return 'https://hls7u7zp0m.execute-api.us-east-1.amazonaws.com/dev';
        case 'staging':
            return 'https://vtukff6jyi.execute-api.us-east-1.amazonaws.com/staging';
        case 'prod':
            return 'https://4k3yk7p9vl.execute-api.us-east-1.amazonaws.com/prod';
    }
};